// Payment platform logos
import phonepeLogo from '../assets/phonepe.jpg';
import gpayLogo from '../assets/gpay.png';
import paytmLogo from '../assets/paytm.png';

// Bank logos — only importing files that exist in assets
import sbiLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=State Bank of India.png';
import hdfcLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=HDFC Bank.png';
import iciciLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=ICICI Bank.png';
import axisLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=Axis bank.png';
import kotakLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=Kotak Mahindra Bank.png';
import yesBankLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=Yes Bank.png';
import pnbLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=Punjab National Bank.png';
import bobLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=Bank of Baroda.png';
import canaraLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=Canara Bank.png';
import unionLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=Union Bank.png';
import idbiLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=IDBI Bank.png';
import indusindLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=Induslnd Bank.png';
import rblLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=RBL Bank.png';
import idfcLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=IDFC Bank.png';
import bandhanLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=Bandhan Bank.png';
import auSmallLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=AU Small Finance Bank.png';
import paytmBankLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=Paytm Payments Bank.png';
import airtelBankLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=Airtel Payments Bank.png';
import jioBankLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=Jio Payments Bank.png';
import finoBankLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=FINO Payments Bank.png';
import indianBankLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=Indian Bank.png';
import boiLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=Bank of India.png';
import centralLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=Central Bank of India.png';
import hsbcLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=HSBC Bank.png';
import citiLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=Citi Bank.png';
import dbsLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=DBS Bank.png';
import scbLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=Standard Chartered Bank.png';
import southIndianLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=South Indian Bank.png';
import karnatakaLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=Karnataka Bank.png';
import indianOverseasLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=Indian Overseas Bank.png';
import bomLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=Bank of Maharastra.png';
import dcbLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=DCB Bank.png';
import dhanlaxmiLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=Dhanlaxmi Bank.png';
import csbLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=CSB Bank.png';
import indiaPostLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=India Post Payments Bank.png';
import ucoLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=UCO Bank.png';
import ujjivanLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=Ujjivan Small Finance Bank.png';
import tamilnadLogo from '../assets/Indian Banks SVG Logos (Community)/Bank Name=Tamilnad Mercantile Bank.png';

export const BANK_LOGOS = {
    'sbi': { abbr: 'SBI', color: '#2B4C9B' },
    'state bank': { abbr: 'SBI', color: '#2B4C9B' },
    'hdfc': { abbr: 'HDFC', color: '#004C8F' },
    'icici': { abbr: 'ICICI', color: '#F37021' },
    'axis': { abbr: 'AXIS', color: '#800020' },
    'kotak': { abbr: 'KOT', color: '#ED1C24' },
    'yes bank': { abbr: 'YES', color: '#0072BC' },
    'pnb': { abbr: 'PNB', color: '#660033' },
    'punjab national': { abbr: 'PNB', color: '#660033' },
    'bob': { abbr: 'BOB', color: '#F26522' },
    'bank of baroda': { abbr: 'BOB', color: '#F26522' },
    'canara': { abbr: 'CAN', color: '#FFD100' },
    'union': { abbr: 'UBI', color: '#009933' },
    'idbi': { abbr: 'IDBI', color: '#006400' },
    'indusind': { abbr: 'IND', color: '#98002E' },
    'rbl': { abbr: 'RBL', color: '#E31837' },
    'idfc': { abbr: 'IDFC', color: '#9D1D35' },
    'bandhan': { abbr: 'BAN', color: '#E41E26' },
    'au small': { abbr: 'AU', color: '#E31837' },
    'paytm payments': { abbr: 'PTM', color: '#00B9F5' },
    'airtel payments': { abbr: 'AIR', color: '#ED1C24' },
    'fino': { abbr: 'FINO', color: '#0072CE' },
    'jio payments': { abbr: 'JIO', color: '#0A2885' }
};

export const SOURCE_LOGOS = {
    'phonepe': phonepeLogo,
    'gpay': gpayLogo,
    'paytm': paytmLogo
};

// Map bank keywords to imported image assets
const BANK_LOGO_MAP = {
    'sbi': sbiLogo,
    'state bank': sbiLogo,
    'hdfc': hdfcLogo,
    'icici': iciciLogo,
    'axis': axisLogo,
    'kotak': kotakLogo,
    'yes bank': yesBankLogo,
    'pnb': pnbLogo,
    'punjab national': pnbLogo,
    'bob': bobLogo,
    'bank of baroda': bobLogo,
    'canara': canaraLogo,
    'union': unionLogo,
    'idbi': idbiLogo,
    'indusind': indusindLogo,
    'rbl': rblLogo,
    'idfc': idfcLogo,
    'bandhan': bandhanLogo,
    'au small': auSmallLogo,
    'paytm payments': paytmBankLogo,
    'airtel': airtelBankLogo,
    'airtel payments': airtelBankLogo,
    'jio': jioBankLogo,
    'jio payments': jioBankLogo,
    'fino': finoBankLogo,
    'indian bank': indianBankLogo,
    'bank of india': boiLogo,
    'central bank': centralLogo,
    'hsbc': hsbcLogo,
    'citi': citiLogo,
    'dbs': dbsLogo,
    'standard chartered': scbLogo,
    'south indian': southIndianLogo,
    'karnataka': karnatakaLogo,
    'indian overseas': indianOverseasLogo,
    'bank of maharashtra': bomLogo,
    'maharashtra': bomLogo,
    'dcb': dcbLogo,
    'dhanlaxmi': dhanlaxmiLogo,
    'csb': csbLogo,
    'india post': indiaPostLogo,
    'uco': ucoLogo,
    'ujjivan': ujjivanLogo,
    'tamilnad': tamilnadLogo
};

export function getBankInfo(accountStr) {
    if (!accountStr) return null;
    var lower = accountStr.toLowerCase();
    for (var key in BANK_LOGOS) {
        if (lower.includes(key)) return BANK_LOGOS[key];
    }
    return null;
}

export function getBankLogo(account) {
    if (!account) return null;
    var lower = account.toLowerCase();
    for (var key in BANK_LOGO_MAP) {
        if (lower.includes(key)) return BANK_LOGO_MAP[key];
    }
    return null;
}
